export class CourseLogEntity {
  id: string;
  courseId: string;
  userId: string;
  sessionId: string;
  createdTimeUtc: Date;
  status: string;
}
